import { Injector } from '@angular/core';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { changeAccountNickname } from '../account-management/change-nickname.utils';
import { deactivateLedgerAccount } from '../account-zone/deactivate-ledger-account';
import { functionCtaType } from '../cta-button-actions.utils';
import { saveSpendingBudgetValues } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/spending-budget/spending-budget-actions.utils';

export const accountManagementActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.CHANGE_ACCOUNT_NICKNAME,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      changeAccountNickname(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.DEACTIVATE_LEDGER_ACCOUNT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      deactivateLedgerAccount(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.SAVE_SPENDING_BUDGET,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      saveSpendingBudgetValues(attri.widgetProperties, injector);
    },
  ],
]);
